<script>
import {
  RectangleStencil,
} from 'vue-advanced-cropper';

export default {
  name: 'ClosedArchStencil',
  extends: RectangleStencil,
  methods: {
    aspectRatios() {
      const max = 1000;
      return {
        minimum: 1 / max,
        maximum: max,
      };
    },
    // For external use
    processCrop(canvas) {
      // Receives square crop. Returns rounded crop.
      const context = canvas.getContext('2d');
      const { width } = canvas;
      const { height } = canvas;
      context.globalCompositeOperation = 'destination-in';
      context.beginPath();
      context.scale(1, height / width);
      context.arc(width / 2, width / 2, width / 2, Math.PI, Math.PI * 2);
      context.lineTo(width, width);
      context.lineTo(0, width);
      context.lineTo(0, width / 2);
      context.closePath();
      context.fill();
      return canvas;
    },
  },
};
</script>
<style lang="scss" scoped>

$border-radius: 50% 50% 0 0;
.vue-rectangle-stencil {
  border-radius: $border-radius;
  cursor: move;
  position: absolute;
  box-sizing: content-box;

  ::v-deep &__handler {
    position: absolute;
    right: 15%;
    top: 14%;
    z-index: 9997;
    cursor: ne-resize;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    transform: translate(50%, -50%);
  }

  ::v-deep &__preview {
    border-radius: $border-radius;
  }
}

</style>
